<template>
  <div :style="{ height: '100%' }">
    <a-layout id="layout" v-if="token && !isPublicRoute">
      <layout-header />
      <a-layout
        :style="{
          marginTop: '64px',
          transition: 'margin-left 0.25s ease'
        }"
      >
        <layout-sidebar :collapsed="collapsed" @toggle-sidebar="toggleSidebar" />
        <a-layout-content style="position: relative">
          <div class="flex align-items-center justify-content-center h-screen" v-if="loading">
            <a-spin size="large" />
          </div>
          <div v-else :class="{ content_wrapper: !isConfigurationPageRoute }">
            <slot />
          </div>
        </a-layout-content>
      </a-layout>
    </a-layout>
    <router-view v-else />
    <agent-view />
    <workspace-window v-if="token && !isPublicRoute">
      <template #default="{ tab }">
        <workflow-visualization v-if="tab.type === 'workflow'" :workflow="tab.workflow" />
      </template>
    </workspace-window>
  </div>
</template>

<script>
import { Layout, notification, Spin } from 'ant-design-vue'
import routesMixin from '@/mixins/routesMixin'
import permissionMixin from '@/mixins/permissionMixin'
import LayoutSider from './layout-sider.vue'
import LayoutHeader from './layout-header.vue'
import { mapActions, mapState } from 'vuex'
import AgentView from '../entities/agent/agent-view.vue'
import WorkspaceWindow from '../entities/workspace/workspace-window.vue'
import WorkflowVisualization from '../entities/visualization/workflow-visualization.vue'

const SIDEBAR_STORAGE_KEY = 'layout-sidebar-collapsed'

export default {
  components: {
    WorkspaceWindow,
    WorkflowVisualization,
    'a-layout': Layout,
    'a-layout-content': Layout.Content,
    'a-spin': Spin,
    'agent-view': AgentView,
    'layout-sidebar': LayoutSider,
    'layout-header': LayoutHeader
  },
  data: function () {
    return {
      collapsed: localStorage.getItem(SIDEBAR_STORAGE_KEY) === 'true'
    }
  },

  mixins: [routesMixin, permissionMixin],

  computed: {
    ...mapState({
      loading: state => state.applicationState.loading
    }),

    user() {
      return this.$store.state.applicationState.user
    },
    token() {
      return this.$store.state.applicationState.token
    },
    isConfigurationPageRoute() {
      return (this.$route?.name || '').startsWith('configuration-page')
    },
    isPublicRoute() {
      return Boolean(this.$route?.meta?.public)
    }
  },

  watch: {
    '$store.state.applicationState.currentProject.id'() {
      this.$store.commit('workspace/clear')
    },
    token: {
      async handler(newVal, oldVal) {
        if (!newVal) this.$store.commit('workspace/clear')
        if (newVal && oldVal === null) return
        if (newVal !== oldVal && newVal !== null) this.fetchAppData()
      },
      immediate: true
    }
  },

  methods: {
    ...mapActions(['loadApplicationState', 'setLoading']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    async fetchAppData() {
      this.setLoading(true)

      try {
        await this.loadApplicationState()
      } catch (error) {
        this.showNotification(
          'error',
          'Error',
          typeof error === 'string' ? error : error?.message || 'Unable to load application data.'
        )
      } finally {
        this.setLoading(false)
      }
    },
    toggleSidebar() {
      this.collapsed = !this.collapsed
      localStorage.setItem(SIDEBAR_STORAGE_KEY, String(this.collapsed))
    }
  }
}
</script>

<style scoped>
.footer {
  text-align: center;
  padding: 20px 50px;
  min-height: 50px;
}

.company_name {
  margin: 0 !important;
  opacity: 1;
  transition:
    opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.company_name.none {
  display: none;
  opacity: 0;
  max-width: 0;
}

.user-profile-wrapper {
  display: flex;
  padding: 5px;
  margin: 10px;
  border-radius: 10px;
  border: 1px solid var(--border-color-base);
  gap: 10px;
}

.user-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
}

.user-details {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-around;
}

.sign-out-button {
  color: #ef4444;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.3s ease;
}

.sign-out-button:hover {
  color: #ff4d4d;
}

.dropdown-icon-trigger:hover {
  cursor: pointer;
}

.unclickable-menu-item {
  cursor: unset !important;
  color: unset !important;
}

.user-dropdown-menu {
  width: 250px;
}
</style>
